import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { Swiper, FreeMode, Pagination } from 'swiper';
import SplitType from 'split-type';

export default class Block04 {
    constructor (query) {
        const el = document.querySelector(query);
        if (!el) return;

        this.el = el;
        this.gsap = gsap;

        this.init();
    }

    init () {
        this.gsap.registerPlugin(ScrollTrigger);

        this.slider();

        if (window.innerWidth > 767) this.drag();

        if (window.innerWidth > 767) {
            this.animation();
        } else {
            this.mobile();
        }
    }

    slider () {
        const slider = this.el.querySelector('.block-04--list.swiper');
        if (!slider) return;

        const swiper = new Swiper(slider, {
            modules: [FreeMode, Pagination],
            slidesPerView: 'auto',
            spaceBetween: 0,
            freeMode: {
                enabled: true,
                momentum: true,
                momentumRatio: 0.75,
                momentumVelocityRatio: 0.5
            },
            pagination: {
                el: '.block-04--pagination',
                dynamicBullets: true,
                clickable: false
            }
        });

        swiper.slides.forEach((slide) => {
            slide.addEventListener('click', () => {
                swiper.slides.filter((s) => s !== slide).forEach((s) => {
                    s.querySelector('.block-04--list-item').classList.remove('animated');
                })

                slide.querySelector('.block-04--list-item').classList.toggle('animated');
            });
        });
    }

    drag () {
        const gthis = this;

        const drag = this.el.querySelector('.block-04--drag');
        if (!drag) return;

        const xSetter = gsap.quickSetter(drag, 'x', 'px');
        const ySetter = gsap.quickSetter(drag, 'y', 'px');

        let mouseX = 0;
        let mouseY = 0;

        window.addEventListener('mousemove', (e) => {
            mouseX = e.clientX - drag.offsetWidth / 2;
            mouseY = e.clientY - drag.offsetHeight / 2 - 12;
        });

        gsap.ticker.add(() => {
            xSetter(mouseX);
            ySetter(mouseY);
        });

        const observer = new MutationObserver(() => {
            const items = gthis.el.querySelectorAll('.block-04--list-item.animated');

            drag.style.opacity = items.length ? 0 : '';
        });

        observer.observe(this.el, { childList: true, subtree: true, attributes: true });
    }

    animation () {
        const team = this.el.querySelector('[data-animation="team"]');

        const title = this.el.querySelector('.site-section--heading .site-title');
        const text = this.el.querySelector('.site-section--heading .site-text');
        const items = this.el.querySelectorAll('.block-04--list .swiper-slide');

        new SplitType(title, { types: 'chars' });

        /* Step: Section */

        if (window.innerWidth >= 768) {
            this.gsap.timeline({
                scrollTrigger: {
                    trigger: team,
                    start: () => 'bottom bottom',
                    end: () => `+=${window.innerHeight * 1.5}px`,
                    pin: true,
                    pinSpacing: false,
                    scrub: true
                }
            });
        }

        /* Step: Content */

        {
            const step = items[0].offsetHeight / 5;

            const timeline = this.gsap.timeline({
                scrollTrigger: {
                    trigger: this.el,
                    start: () => 'top bottom',
                    end: () => `+=${this.el.offsetHeight}px`,
                    scrub: true
                }
            });

            timeline.set(text, { opacity: 0, y: '50%' });

            [...items].forEach((item, index) => {
                timeline.set(item, { y: (index + 1) * step });
            });

            timeline
                .to({},        { duration: 0, onUpdate: () => title.classList.remove('animated') })
                .to({},        { duration: 1 })
                .to({},        { duration: 1, onUpdate: () => title.classList.add('animated') })
                .to(text,      { duration: 1, opacity: 1, y: 0 });

            [...items].forEach((item) => {
                timeline.to(item, { duration: 2, y: 0 }, '<');
            });
        }
    }

    mobile () {
        const title = this.el.querySelector('.site-section--heading .site-title');
        const text = this.el.querySelector('.site-section--heading .site-text');
        const list = this.el.querySelector('.block-04--list');
        
        title.classList.add('site-animation', 'fade-up');
        text.classList.add('site-animation', 'fade-up');
        list.classList.add('site-animation', 'fade-in');

        [title, text, list].forEach((element) => {
            gsap.timeline({
                scrollTrigger: {
                    trigger: element,
                    start: 'top bottom',
                    once: true,
                    onEnter: () => element.classList.add('animated')
                }
            });
        });
    }
}
